import { Theme } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<{ statusType: string }>()(
  (theme: Theme, { statusType }) => ({
    bannerRoot: {
      marginTop: theme.spacing(-4),
      minHeight: theme.spacing(4),
      height: 'auto',
      padding: theme.spacing(0.5, 0),
      width: 'calc(100% + 475px)',
      marginLeft: theme.spacing(-5),
      backgroundColor:
        statusType === 'expired'
          ? theme.palette.backgroundV2.tertiary
          : theme.palette.backgroundV2.hint,
    },
    bannerContent: {
      marginLeft: theme.spacing(5),
      marginTop: theme.spacing(0.5),
    },
    highlightText: {
      color: theme.palette.error.main,
    },
    settingsLink: {
      color: theme.palette.primary.main,
    },
  })
)
